import { guestLinks } from '@map/components/GuestArea/links';
import { buildApiUrl } from '@map/hooks/baseApi';
import { updateProjectFeatures } from '@map/hooks/useFeatureIsAccessible';
import { actionCreators } from '@map/state/profile';
import { ThemeColors, windowExtended } from '@map/types';
import useMountEffect from '@shared/hooks/useMountEffect';
import useNavigate from '@shared/hooks/useNavigate';
import axios from 'axios';
import { ComponentProps, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import AccessCodeForm from '../AccessCodeForm';
import Menu from './Menu';

type ApiResponse = {
  ok: boolean;
  title?: string;
  themeColors?: ThemeColors;
  features?: string[];
  slug?: string;
};

let accessCodeSeen = false;

const AccessCode = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = useCallback<ComponentProps<typeof AccessCodeForm>['onSubmit']>(
    (values, { setFieldError }) =>
      axios
        .get<ApiResponse>(buildApiUrl('users/check_code'), {
          params: { access_code: values.access_code },
        })
        .then(({ data }) => {
          const { ok, title, themeColors, features, slug } = data;
          if (ok) {
            windowExtended.project = {
              ...windowExtended.project,
              title: title!,
              slug,
              access_code: values.access_code,
            };
            if (features) {
              updateProjectFeatures(features);
            }
            if (themeColors) {
              windowExtended.themeColors = themeColors;
              dispatch(actionCreators.profileUpdated({}));
            }
            accessCodeSeen = true;
            if (slug) {
              window.location.pathname = guestLinks.projectRegisterMenu(slug);
            } else {
              navigate(guestLinks.registerMenu(), { replace: true });
            }
          } else {
            // i18n-tasks-use t('registration.errors.access_code_invalid')
            setFieldError('access_code', 'registration.errors.access_code_invalid');
          }
        })
        .catch(console.warn),
    [dispatch, navigate],
  );
  // if the user has already entered the code previously, or the code exists from an invitation,
  // or the user accessed the page via a project url, we just briefly show this screen
  // we only do this once and simply show the menu on subsequent navigations
  useMountEffect(() => {
    if (!accessCodeSeen && windowExtended.project.access_code) {
      const timeout = setTimeout(() => {
        accessCodeSeen = true;
        navigate(guestLinks.registerMenu(), { replace: true });
      }, 1000);
      return () => clearTimeout(timeout);
    }
  });

  if (accessCodeSeen) {
    return <Menu />;
  }

  return <AccessCodeForm onSubmit={handleSubmit} />;
};

export default AccessCode;
